void import('@app').then(async ({ appBootstrap }) => {
  await appBootstrap();
}).catch((error) => {
  // eslint-disable-next-line no-console
  console.error('[shell] Fatal bootstrap error:', error);
});
